<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header">
              <h4 class="title">
                Tool-sets
              </h4>
            </div>

            <div class="md-card-content">
              <md-table v-model="tools" md-card>
                <md-table-toolbar>
                  <h1 class="md-title">PipeScanners</h1>
                  <md-button
                    @click="add_tools"
                    type="submit"
                    class="md-danger"
                    style="background-color: #8dc63f"
                    >Add PipeScanner</md-button
                  >
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Etag">{{ item.id }}</md-table-cell>
                  <md-table-cell md-label="Type" md-sort-by="type">{{
                    item.type
                  }}</md-table-cell>
                  <md-table-cell md-label="Version" md-sort-by="version">{{
                    item.version
                  }}</md-table-cell>
                  <md-table-cell md-label="Address" md-sort-by="address">{{
                    item.address
                  }}</md-table-cell>
                  <md-table-cell md-label="Action"
                    ><md-button
                      type="submit"
                      class="md-primary"
                      style="background-color: #8dc63f"
                      @click="edit_tool(item)"
                      >View / Edit</md-button
                    ></md-table-cell
                  >
                </md-table-row>
              </md-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  beforeCreate() {},
  components: {},
  data() {
    return {
      tools: [],
    };
  },
  mounted() {
    //check if pipescanner is a service for this group
    if (!this.groupServices.includes("pipescanner-inspections")) {
      this.$router.push("/");
    } else {
      //console.log("oh hi there!");
      this.get_tools();
    }
  },
  computed: {
    ...mapState(["apiEndpoints", "groupServices", "groupSelected"]),
  },
  watch: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
  },
  methods: {
    ...mapMutations(["SET_SELECTED_EDIT_TOOL"]),
    /**
     * route to edit tool page
     */
    edit_tool(toolObject) {
      this.SET_SELECTED_EDIT_TOOL(toolObject);
      this.$router.push("/edit-tool");
    },
    /**
     * route to add tool page
     */
    add_tools() {
      this.$router.push("/add-tools");
    },
    /**
     * query tools from api
     */
    async get_tools() {
      var token = await this.$auth.getTokenSilently();

      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      var endpoint = this.apiEndpoints.base + this.apiEndpoints.tools.query;

      axios
        .get(endpoint, header)
        .then((response) => {
          this.tools = response.data[this.groupSelected];
          console.log(this.tools);
        })
        .catch(() => {
          this.$notify({
            message: "Error ",
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
